<template>
    <div>
      <div class="row">
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-btn">
                        <button type="button" class="btn bg-light-blue btn-sm waves-effect" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons" title="Tambah Data">add</i></button>
                    </span>
                    <input type="text" class="form-control" style="background: #e4e4e3" placeholder="Cari data" id="caridata" @keyup="cari_data" v-model="cari_value">
                </div>
            </div> 
        </div>
      <div class="table-responsive">
        <table class="table table-bordered" style="width: 100%">
            <thead>
            <tr class="bg-info text-center">
                <th class="text-center" style="width: 5%; vertical-align: middle;">No.</th>
                <th class="text-center" style="width: 50%; vertical-align: middle;">Nama Pegawai</th>
                <th class="text-center" style="width: 30%; vertical-align: middle;">Nomor Induk Pegawai</th>
                <th class="text-center" style="width: 15%; vertical-align: middle;">

                </th>
            </tr>
            </thead>
            <tbody>
              <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id">
                  <td class="text-center">{{index+1}}.</td>
                  <td>{{data.nm_pegawai}}</td>
                  <td class="text-center">{{data.nip}}</td>
                  <td class="text-center" >

                    <button @click="getView(data.id, data.nip, data.nm_pegawai)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                        <i class="material-icons" >create</i>
                    </button>
                    	&nbsp;
                    <button @click="removeData(data.id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                        <i class="material-icons" >clear</i>
                    </button>
                  </td>
              </tr>

            </tbody>
        </table>
      </div>

      <hr>
        <div class="text-center">
            <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                    <i class="material-icons">skip_previous</i>
            </button>

            <span style="font-size: 85%; color: #a5a5a5"><b>	&nbsp; {{page_first}} - {{page_last}} 	&nbsp;</b></span>

            <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                    <i class="material-icons">skip_next</i>
            </button>
        </div>
      <hr>


      <!-- ============================================================ MODAL ======================================================================== -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>
                                <div class="modal-body">

                                  <div class="row clearfix">
                                      <div class="col-md-3 form-control-label">
                                          <label for="kode">NIP</label>
                                      </div>
                                      <div class="col-md-9">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input v-model="nip" type="text" class="form-control">
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="row clearfix">
                                      <div class="col-md-3 form-control-label">
                                          <label for="kode">Nama Pegawai</label>
                                      </div>
                                      <div class="col-md-9">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input v-model="nm_pegawai" type="text" class="form-control">
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                </div>
                                <div class="modal-footer">
                                    <button @click="addData" type="button" class="btn btn-info waves-effect">SIMPAN</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="row clearfix">
                                        <div class="col-md-3 form-control-label">
                                            <label for="kode">NIP</label>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="nip" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-3 form-control-label">
                                            <label for="kode">Nama Pegawai</label>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="nm_pegawai" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button @click="editData" type="button" class="btn btn-success waves-effect">RUBAH</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- ============================================================ MODAL ======================================================================== -->

    </div>
</template>


<script>
    import Autocomplete from 'vue2-autocomplete-js'
    const URL_SERVER = URL_APP;
    const URL_DATI2 = URL_APP+'api/v1/bhumie_dati2/';
    const ADD_URL = URL_APP+'api/v1/bhumie_pegawai/';


    export default {
    name: "bhumie_kecamatan",
    components: { Autocomplete },
    data() {
        return {
            id: "",
            nip: "",
            nm_pegawai: "",

            edit_data : false,
            list_data: [],
            page_first: 1,
            page_last: 0,
            cari_value: "",
            token : localStorage.token,
            URL : URL_SERVER
        };
    },

    // =============================================================== METHODS =========================================================================
    methods : {
        getData : function(){
            fetch(ADD_URL+'view', {
                method : 'POST',
                headers : {
                'content-type' : 'application/json',
                authorization : "kikensbatara "+ localStorage.token
                },
                body : JSON.stringify({
                data_ke: this.page_first,
                cari_value: this.cari_value
                })
            }).then(res => res.json())
                .then((data_res) => {
                    this.list_data = data_res.data;
                    this.page_last = data_res.jml_data
                    // console.log(data_res);
                })
        },

        addData : function(){
            fetch(ADD_URL+'add', {
                method : 'POST',
                headers : {
                'content-type' : 'application/json',
                authorization : 'kikensbatara '+ localStorage.token,
                },
                body : JSON.stringify({
                    nip : this.nip,
                    nm_pegawai : this.nm_pegawai,
                })
            }).then((res_data)=>{
                this.alertku("success", "sukses menambah data");
                this.getData();
            });
        },

        editData : function(){
            fetch(ADD_URL+'update', {
                method : 'POST',
                headers : {
                'content-type' : 'application/json',
                authorization : 'kikensbatara '+localStorage.token
                },
                body : JSON.stringify({
                    id : this.id,
                    nip : this.nip,
                    nm_pegawai : this.nm_pegawai,
                })
            }).then((res_data)=>{
                this.alertku("success", "sukses mengubah data");
                this.getData();
            })
        },

        removeData : function(id){
            fetch(ADD_URL+"remove", {
                method : 'POST',
                headers : {
                'content-type' : 'application/json',
                authorization : "kikensbatara "+ localStorage.token,
                },
                body : JSON.stringify({
                  id : id,
                })
            }).then(()=>{
                this.alertku("success", "sukses menghapus data");
                this.getData();
            })
        },

        getView : function(id, nip, nm_pegawai){
            this.id = id;
            this.nip = nip;
            this.nm_pegawai = nm_pegawai;
            // this.edit_data = true;
        },

        exit_modal : function(){
          this.edit_data = false;
        },


    // ================== PAGINASI ====================
        alertku: function(type, title) {
            this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
            });
        },

        btn_prev: function() {
        if (this.page_first > 1) {
            this.page_first--;
        } else {
            this.page_first = 1;
        }
        this.getData();
        },

        btn_next: function() {
        if (this.page_first >= this.page_last) {
            this.page_first == this.page_last;
        } else {
            this.page_first++;
        }
        this.getData();
        },

        cari_data: function() {
        this.getData();
        },
    // ================== PAGINASI ====================

    // ================== AUTOCOMPLETED ====================
        getAuto : function(obj){
        // console.log(obj);
        this.nm_dati2 = obj.nm_dati2;
        this.kd_dati2 = obj.kd_dati2;
        },
        renderChild(data) {
            return `
            <span><b>${data.nm_dati2}</b></span>
            <span style='font-size:80%'>${data.nm_propinsi}</span>
            `
        },
    // ================== AUTOCOMPLETED ====================

    },
    // =============================================================== METHODS =========================================================================

    mounted() {
        this.getData();
        // this.autocompleted();
    },
    };
</script>
